/**
 * Animated Counter Frontend
 * Handles the animation of counters when they come into view
 */

(function ($) {
	'use strict';

	// Check if text contains at least one digit
	function hasNumber(text) {
		return /\d/.test(text);
	}

	// Counter animation function
	function animateCounter($element) {
		// Get the original text and parse the number
		const originalText = $element.attr('data-original-text') || $element.text();

		// If there's no number in the text, leave it as is
		if (!hasNumber(originalText)) return;

		const isDecimal = originalText.includes('.');
		const hasComma = originalText.includes(',');
		const numericText = originalText.replace(/[^0-9.]/g, '').replace(/,/g, '');
		const target = parseFloat(numericText);

		if (isNaN(target) || target === 0) return;

		// Extract prefix and suffix (non-numeric parts)
		const matches = originalText.match(/^([^\d]*)(.+?)([^\d]*)$/);
		const prefix = matches ? matches[1] : '';
		const suffix = matches ? matches[3] : '';

		let current = 0;
		const increment = target / 100; // Animation in 100 steps
		const duration = 700; // 2 seconds
		const stepTime = duration / 100;

		$element.addClass('counting');

		const timer = setInterval(function () {
			current += increment;

			if (current >= target) {
				current = target;
				clearInterval(timer);
				$element.removeClass('counting');
			}

			// Format the number
			let displayValue = current;

			if (isDecimal) {
				// Count decimal places in original
				const decimalPlaces = (originalText.match(/\.(\d+)/) || ['', ''])[1].length;
				displayValue = current.toFixed(decimalPlaces);
			} else {
				displayValue = Math.floor(current).toString();
			}

			// Add commas if original had them
			if (hasComma && displayValue >= 1000) {
				displayValue = displayValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			}

			$element.text(prefix + displayValue + suffix);
		}, stepTime);
	}

	function startAnimatedCounter(el) {
		if (!el || el.classList.contains('animated')) {
			return;
		}

		el.classList.add('animated');
		animateCounter($(el));
	}

	window.startAnimatedCounter = startAnimatedCounter;

	function inStatsEq(el) {
		return !!el.closest('.stats-eq');
	}

	// Intersection Observer for scroll-triggered animation
	function initCounters() {
		const counters = document.querySelectorAll('.animated-counter');

		if (counters.length === 0) return;

		// set the initial value to 0
		counters.forEach(function (counter) {
			if (counter.classList.contains('animated') || counter.getAttribute('data-original-text')) {
				return;
			}

			const originalText = counter.textContent.trim();

			// Skip if there's no number in the text (just a string or blank)
			if (!hasNumber(originalText)) return;

			const matches = originalText.match(/^([^\d]*)(.+?)([^\d]*)$/);
			const prefix = matches ? matches[1] : '';
			const suffix = matches ? matches[3] : '';
			counter.textContent = prefix + '0' + suffix;

			// keep the original text in a data attribute
			counter.setAttribute('data-original-text', originalText);
		});

		// Check if Intersection Observer is supported
		if ('IntersectionObserver' in window) {
			const observer = new IntersectionObserver(
				function (entries) {
					let toAnimate = [];
					entries.forEach(function (entry) {
						if (entry.isIntersecting && !entry.target.classList.contains('animated')) {
							toAnimate.push(entry.target);
						}
					});
					if (toAnimate.length > 0) {
						// Sort by vertical position
						toAnimate.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);
						// Animate with stepped delays (half the animation duration: 350ms)
						toAnimate.forEach((counter, index) => {
							const delay = index * 350;
							setTimeout(() => {
								if (!counter.classList.contains('animated')) {
									counter.classList.add('animated');
									animateCounter($(counter));
									observer.unobserve(counter);
								}
							}, delay);
						});
					}
				},
				{
					threshold: 0.5, // Trigger when 50% visible
					rootMargin: '0px 0px -50px 0px', // Trigger slightly before fully visible
				},
			);

			counters.forEach(function (counter) {
				if (inStatsEq(counter)) {
					return;
				}

				observer.observe(counter);
			});
		} else {
			// Fallback for older browsers - animate on scroll
			$(window).on('scroll', function () {
				let toAnimate = [];
				counters.forEach(function (counter) {
					if (counter.classList.contains('animated') || inStatsEq(counter)) return;

					const rect = counter.getBoundingClientRect();
					const windowHeight = window.innerHeight;

					if (rect.top <= windowHeight * 0.8) {
						toAnimate.push(counter);
					}
				});
				if (toAnimate.length > 0) {
					// Sort by vertical position
					toAnimate.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);
					// Animate with stepped delays
					toAnimate.forEach((counter, index) => {
						const delay = index * 350;
						setTimeout(() => {
							if (!counter.classList.contains('animated')) {
								counter.classList.add('animated');
								animateCounter($(counter));
							}
						}, delay);
					});
				}
			});
		}
	}

	// Initialize when DOM is ready
	$(document).ready(function () {
		initCounters();
	});

	// Re-initialize for dynamic content (if needed)
	window.initCounters = initCounters;
})(jQuery);
